// @flow

import React, { type Node } from 'react';
import { InputCustomerZipcode } from '../input-customer-zipcode';

export function InputPeruvianZipcode(): Node {
  return (
    <InputCustomerZipcode
      mask={MASK}
      fieldName="peruvianZipcode"
    />
  );
}

const MASK = Array(5).fill(/\d/);
